import UrlPattern from 'url-pattern'

/**
 * External Service Helper
 */
export default class ExternalService {
  /**
   *
   * @param {Object} proxyOptions
   */
  constructor (proxyOptions) {
    this.proxyOptions = proxyOptions
  }

  /**
   *
   * @param {string} urlPattern
   * @param {Object} options
   * @return {string}
   */
  getServiceUrl (urlPattern, options = {}) {
    const {
      enabled,
      route
    } = this.proxyOptions

    const serviceUrlPattern = new UrlPattern(urlPattern)

    return enabled
      ? `${route}/${encodeURIComponent(serviceUrlPattern.stringify(options))}`
      : serviceUrlPattern.stringify(options)
  }
}
